import { combineReducers } from "redux";
import { stellaInfoReducer } from "./stellaInfo/stellaInfoReducer";

export const rootReducer = combineReducers({
  stellaInfo: stellaInfoReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
